import axiosInstance from '../utils/axiosConfig';

const BASE_URL = '/api/corporate-structure';

// ============================================================================
// CORPORATE GROUPS
// ============================================================================

export const fetchGroups = async () => {
  const response = await axiosInstance.get(`${BASE_URL}/groups/`);
  return response.data;
};

export const fetchGroup = async (id) => {
  const response = await axiosInstance.get(`${BASE_URL}/groups/${id}/`);
  return response.data;
};

export const createGroup = async (data) => {
  const response = await axiosInstance.post(`${BASE_URL}/groups/`, data);
  return response.data;
};

export const updateGroup = async (id, data) => {
  const response = await axiosInstance.patch(`${BASE_URL}/groups/${id}/`, data);
  return response.data;
};

export const archiveGroup = async (id) => {
  const response = await axiosInstance.delete(`${BASE_URL}/groups/${id}/`);
  return response.data;
};

// ============================================================================
// CORPORATE ENTITIES
// ============================================================================

export const fetchEntities = async (groupId) => {
  const response = await axiosInstance.get(`${BASE_URL}/groups/${groupId}/entities/`);
  return response.data;
};

export const fetchEntity = async (id) => {
  const response = await axiosInstance.get(`${BASE_URL}/entities/${id}/`);
  return response.data;
};

export const createEntity = async (groupId, data) => {
  const response = await axiosInstance.post(`${BASE_URL}/groups/${groupId}/entities/create/`, data);
  return response.data;
};

export const updateEntity = async (id, data) => {
  const response = await axiosInstance.patch(`${BASE_URL}/entities/${id}/`, data);
  return response.data;
};

export const archiveEntity = async (id) => {
  const response = await axiosInstance.delete(`${BASE_URL}/entities/${id}/`);
  return response.data;
};

export const hardDeleteEntity = async (id) => {
  const response = await axiosInstance.delete(`${BASE_URL}/entities/${id}/hard-delete/`);
  return response.data;
};

// ============================================================================
// GRAPH DATA (React Flow)
// ============================================================================

export const fetchGraphData = async (groupId) => {
  const response = await axiosInstance.get(`${BASE_URL}/groups/${groupId}/graph/`);
  return response.data;
};

// ============================================================================
// ACCESS MANAGEMENT
// ============================================================================

export const fetchEntityAccess = async (entityId) => {
  const response = await axiosInstance.get(`${BASE_URL}/entities/${entityId}/access/`);
  return response.data;
};

export const grantAccess = async (entityId, data) => {
  const response = await axiosInstance.post(`${BASE_URL}/entities/${entityId}/access/`, data);
  return response.data;
};

export const updateAccess = async (accessId, data) => {
  const response = await axiosInstance.patch(`${BASE_URL}/access/${accessId}/`, data);
  return response.data;
};

export const revokeAccess = async (accessId) => {
  const response = await axiosInstance.delete(`${BASE_URL}/access/${accessId}/`);
  return response.data;
};

export const fetchAccessAudit = async (entityId) => {
  const response = await axiosInstance.get(`${BASE_URL}/entities/${entityId}/access/audit/`);
  return response.data;
};

export const fetchMyEntities = async () => {
  const response = await axiosInstance.get(`${BASE_URL}/my-entities/`);
  return response.data;
};

// ============================================================================
// LINKABLE RESOURCES
// ============================================================================

export const fetchLinkableHMSEntities = async () => {
  const response = await axiosInstance.get(`${BASE_URL}/linkable/hms-entities/`);
  return response.data;
};

export const fetchLinkableCRMProfiles = async () => {
  const response = await axiosInstance.get(`${BASE_URL}/linkable/crm-profiles/`);
  return response.data;
};

export const fetchLinkableOffices = async () => {
  const response = await axiosInstance.get(`${BASE_URL}/linkable/offices/`);
  return response.data;
};
